import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NewNicaFormComponent } from '../../nica-form/new-nica-form.component';
import { confirm } from 'devextreme/ui/dialog';
import { FormsTemplateService } from '../../../services/forms-template.service';
//import moment = require('moment');
interface RangeCondition {
  ge?: string;
  le?: string;
}
@Component({
  selector: 'app-nica-filtro',
  templateUrl: './nica-filtro.component.html',
  styleUrls: ['./nica-filtro.component.css', '../../../views/movimenti-carico-scarico/movimenti-carico-scarico.component.css', '../../../views/ana-soggetto/ana-soggetto.component.css', '../../../components/nica-anagrafica/nica-anagrafica.component.css', "../../../components/nica-anagrafica/nica-anagrafica.component.style.css", "../../../components/nica-anagrafica/nica-anagrafica-template.css"]
})
export class NicaFiltroComponent implements OnInit {

  annullaFiltro() {
    throw new Error('Method not implemented.');
  }
  /** Nome Key da salvare in sessionStorage (NB devono essere univoci) */
  @Input() filtroKeySessionStorage?: string;
  @Input() captionHidden: boolean = false;
  @Input() nomeTemplate?: string;
  @Input() nColForm?: number = 2;
  @Input() caricaUltimoFiltroEnabled: boolean = true;
  @Output() filterQueryStringEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAllEventFiltroForm: EventEmitter<any> = new EventEmitter<any>();
  @Input() height?: number;
  @Input() helpDoc?: string = '-';
  @ViewChild('filtroForm', {
    static: false
  }) filtroForm: NewNicaFormComponent;
  ultimiFiltriCaricati: boolean = true;
  @Input() caption?: string = 'Filtri Avanzati';
  @Input() buttonCustomFormFiltri?: any[];
  buttonToolbarUp: any[] = []; //{ name: 'Documenti', icon: 'glyphicon icon-documenti-form',text:'Documenti' ,hint: 'Documenti', value: 'AllegatiComponent', costantValue: 'movimentorifiuti',dataSource: 'AllegatiComponent', event: '1', location: 'top', displayMode: 'in-line', visible: true }
  buttonToolbarBottom: any[] = [] //{ name: 'Card', icon: 'glyphicon icon-documenti-form', hint: 'Lista Card', value: 'popup', costantValue: '', dataSource: 'NicaCardComponent', event: '1', location: 'top', displayMode: 'in-line', visible: true }];
  isSessionFilter: boolean = false;
  InAttesaOpen: boolean = false;
  timeInterval: NodeJS.Timer;
  popupVisibile: boolean = false;
  dataJson: any = {};  // Nuova proprietà per contenere i dati JSON del filtro

  constructor() { }

  async ngOnInit() {



    this.buttonCustomFormFiltri = [
      {
        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        stylingMode: 'text',
        text: 'Applica',
        icon: "glyphicon icon-salva-form",
        event: 'salva'
      },
      {
        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        stylingMode: 'text',
        text: 'Annulla',
        icon: "glyphicon icon-annulla-form",
        event: 'annulla'
      }
    ];


    if (sessionStorage.getItem('Filtri')) {
      const filtriOBJ = JSON.parse(sessionStorage.getItem('Filtri'))

      const MydataSet = filtriOBJ && this.filtroKeySessionStorage && filtriOBJ[this.filtroKeySessionStorage] ? filtriOBJ[this.filtroKeySessionStorage]['data'] : {};



      if (Object.keys(MydataSet).length > 0) {


        this.dataJson = MydataSet;
        this.isSessionFilter = true


      }
    }
  }

  onAllEventForm(event: any) {

    if (event && typeof event === 'object' && event.name) {
      if (event.name === 'salva') {
        this.onSalva();
      } else if (event.name === 'annulla') {
        this.onAnnulla();
      }
    }
  }

  onSalva() {

    if (!this.filtroForm.validate().isValid) return;

    // Salva i dati del form nel sessionStorage
    let dataForm = JSON.parse(JSON.stringify(this.filtroForm.dataSet))
    const filtriOBJ = JSON.parse(sessionStorage.getItem('Filtri') || '{}');

    filtriOBJ[this.filtroKeySessionStorage] = {
      data: dataForm
    };
    sessionStorage.setItem('Filtri', JSON.stringify(filtriOBJ));
    this.filtroForm.generaOdata().then((oData) => {
      return {
        name: 'queryOk',
        oData
      };
    }).then((eveToEmit) => {
      this.filterQueryStringEmitter.emit(eveToEmit);
    });
  }

  onAnnulla() {
    if (this.isSessionFilter) {
      confirm('Vuoi annullare i filtri applicati?', 'Attenzione!').then(res => {
        if (res) {

          this.eliminaFiltroApplicato();
          this.filtroForm.dataSet = [];

          let eveToEmit = {
            name: 'resettaFiltro',
          };

          this.filterQueryStringEmitter.emit(eveToEmit);

          return
        }
      })
    }

    this.filtroForm.dataSet = [];
    let eveToEmit = {
      name: 'return',
    };
    this.filterQueryStringEmitter.emit(eveToEmit);
  }

  initFormfiltri(event) {

  }

  // isensitivi i prefissi uL e sD
  generaODataQueryString() {

    let sDQueryParts = [];
    let ulQueryParts = [];
    let genericQueryParts = [];
    const formData = this.filtroForm.dataSet;

    Object.keys(formData).forEach(key => {
      let value = formData[key];
      let isCheckbox = typeof value === 'boolean';

      if (value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0) || (isCheckbox && value === false)) {
        return;
      }

      let isDateField = key.includes('Data');
      let isMinQuantita = key === 'minquantitaKg';
      let isMaxQuantita = key === 'maxquantitaKg';
      let modifiedKey = key;

      if (isDateField) {
        modifiedKey = key.replace(/^da|a/, '');
        modifiedKey += key.startsWith('da') ? ' ge' : ' le';
      }

      if (isMinQuantita || isMaxQuantita) {
        modifiedKey = 'quantitaKg';
        if (isMinQuantita) {
          ulQueryParts.push(`${modifiedKey} ge ${value}`);
        } else if (isMaxQuantita) {
          ulQueryParts.push(`${modifiedKey} le ${value}`);
        }
      } else if (key.startsWith('sD_')) {
        sDQueryParts.push(this.generateFilterPart(modifiedKey, value));
      } else if (key.startsWith('ul_')) {
        ulQueryParts.push(this.generateFilterPart(modifiedKey, value));
      } else {
        genericQueryParts.push(this.generateFilterPart(modifiedKey, value));
      }
    });

    let combinedQueryParts = [];
    if (sDQueryParts.length > 0) {
      combinedQueryParts.push(`(${sDQueryParts.join(' and ')})`);
    }
    if (ulQueryParts.length > 0) {
      combinedQueryParts.push(`(${ulQueryParts.join(' and ')})`);
    }
    if (genericQueryParts.length > 0) {
      combinedQueryParts.push(`(${genericQueryParts.join(' and ')})`);
    }

    let filterODataString = combinedQueryParts.length > 0 ? `?$filter=${combinedQueryParts.join(' and ')}` : '';
    console.log('Filtro generato:', filterODataString);
    return filterODataString;
  }

  generateFilterPart(key, value) {
    if (Array.isArray(value)) {
      const filters = value.map(val => {
        if (typeof val === 'string') {
          const formattedValue = this.formatDateForOData(val);
          return `contains(tolower(${key}), '${formattedValue.replace(/'/g, "''").toLowerCase()}')`;
        }
        return '';
      }).filter(part => part);
      return filters.join(' or ');
    } else if (typeof value === 'string') {
      if (value.match(/^\d{4}-\d{2}-\d{2}/)) {
        const formattedDate = this.formatDateForOData(value.split('T')[0]);
        return `${key} ${formattedDate}`;
      } else {
        return `contains(tolower(${key}), '${value.replace(/'/g, "''").toLowerCase()}')`;
      }
    } else if (typeof value === 'number' || typeof value === 'boolean') {
      return `${key} eq ${value}`;
    }
    return '';
  }

  formatDateForOData(dateString) {
    const moment = require('moment');
    if (dateString && moment(dateString, moment.ISO_8601, true).isValid()) {
      return moment(dateString).format('YYYY-MM-DD');
    }
    return dateString;
  }
  //funzione inutile per la data , ma se la tolgo altre cose non funzionano Adele-
  public static formattaData(data: Date): string {
    const moment = require('moment');
    let tt = moment(data).format("YYYY-MM-DD"); // forse volevi fare questo ??
    //return tt;
    let date, month, year, hour, minute;
    date = data.getDate();
    month = data.getMonth() + 1;
    year = data.getFullYear();
    hour = data.getHours();
    minute = data.getMinutes();
    if (date < 10) {
      date = '0' + date;
    }
    if (month < 10) {
      month = '0' + month;
    }
    if (hour < 10) {
      hour = '0' + hour;
    }
    if (minute < 10) {
      minute = '0' + minute;
    }
    date = date
      .toString()
      .padStart(2, '0');
    month = month
      .toString()
      .padStart(2, '0');
    hour = hour
      .toString()
      .padStart(2, '0');
    minute = minute
      .toString()
      .padStart(2, '0');
    return `${year}-${month}-${date}`;
  }

  /** Elimina il filtro dal sessionStorage */
  async eliminaFiltroApplicato(key?: string) {

    let filtriOBJ = JSON.parse(sessionStorage.getItem('Filtri') || '{}');
    if (!filtriOBJ) {
      return;
    }
    if (key) {
      delete filtriOBJ[key];
    } else {
      delete filtriOBJ[this.filtroKeySessionStorage];
    }
    sessionStorage.setItem('Filtri', JSON.stringify(filtriOBJ));

  }


}